import isEmpty from "lodash/isEmpty";

import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { isBuyNowPayLater } from "@/react/helpers/paywallCheckoutHelpers";

import { PaywallsCheckoutAttemptsAddressElement } from "../../../Attempts/AddressElement";
import { CheckoutFormBusinessNameField } from "../CheckoutFormBusinessNameField";
import { CheckoutFormNameField } from "../CheckoutFormNameField";
import { PaymentElement } from "./PaymentElement";
import { useIsPaymentElementRequired } from "./useIsPaymentElementRequired";

export const Elements = () => {
  const {
    currentUser,
    isMemberAddressRequired,
    memberBillingInfo,
    stripePaymentMethodType: paymentMethodType,
  } = usePaywallCheckoutContext();

  const isPaymentElementRequired = useIsPaymentElementRequired();

  const isAddressMissing =
    !currentUser ||
    isEmpty(memberBillingInfo) ||
    !memberBillingInfo?.address_complete;
  const isAddressRequired =
    isMemberAddressRequired || isBuyNowPayLater(paymentMethodType);
  const isAddressElementRequired = isAddressRequired && isAddressMissing;
  const isNameFieldRequired = !isAddressElementRequired && !currentUser;
  const shouldShowBusinessNameField = !memberBillingInfo?.business_name;

  return (
    <>
      {isPaymentElementRequired && <PaymentElement />}
      {isAddressElementRequired && <PaywallsCheckoutAttemptsAddressElement />}
      {isNameFieldRequired && <CheckoutFormNameField />}
      {shouldShowBusinessNameField && <CheckoutFormBusinessNameField />}
    </>
  );
};
